export default "__VITE_ASSET__LAkIbhpT__"